import { all } from 'redux-saga/effects';
import authenticateSaga from 'features/Auth/authenticateAPI';
import eligibilitySaga from 'features/Eligibility/eligibilityAPI';
import projectSaga from 'features/Project/projectAPI';
import expertSaga from 'features/Expert/expertAPI';
import planSaga from 'features/Plan/planAPI';
import profileSaga from 'features/Profile/profileAPI';
import createProject from 'features/CreateProject/reducers/CreateProjectAPI';

// Here you can include all the saga which you write for components
export default function* rootSaga() {
  yield all([
    authenticateSaga(),
    eligibilitySaga(),
    planSaga(),
    projectSaga(),
    expertSaga(),
    profileSaga(),
    createProject(),
  ]);
}
